import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ru",
  "use": "icon-icon-ru-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ru\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#fff\" d=\"M0 0h512v512H0z\" />\n    <path fill=\"#0039a6\" d=\"M0 170.7h512V512H0z\" />\n    <path fill=\"#d52b1e\" d=\"M0 341.3h512V512H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol